module.exports = __webpack_public_path__ + "static/img/84124A_2_3_R_20181117_LC.1a36628.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/84124A_2_3_R_20181117_LC.png
// module id = 8qYT
// module chunks = 0